<app-dialog-component (okEmitter)="saveAndClose()" *ngIf="newPasswordForm" [formGroup]="newPasswordForm"
                      [formHasToBeEdited]="true" [title]="title">
  <app-password-form [newPasswordForm]="newPasswordForm" [previousPasswordNecessary]="true"></app-password-form>
</app-dialog-component>
